import css from './WalletExtraDesktop.module.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import DataTestId from 'meta/dataTestId'
import { Breakpoints } from 'meta/layout/breakpoints'
import { Dates } from 'utils/dates'

import { ButtonWhiteBlack } from 'components/Actions/Action'
import { GridColumn } from 'components/Layout/Grid'
import Img from 'components/Media/Img'

import TicketDataFetcher from '../../BulkDataFetcher/TicketDataFetcher/TicketDataFetcher'
import UserExtras from './UserExtras'
import { getExtraIconImageNameAccordingToPolicy } from './utils'
import { WalletExtraDesktopProps } from './WalletExtraDesktopContainer'

const WalletExtraDesktop: React.FC<WalletExtraDesktopProps> = (props) => {
  const { baseProps, eventData } = props
  const { walletEventData, isPastEvent, isUsable, setIsThereAtLeastOne } = baseProps
  const { count } = walletEventData

  const { t } = useTranslation()

  const [showTickets, setShowTickets] = useState<boolean>(false)
  const [fetchBulkData, setFetchBulkData] = useState<boolean>(false)

  const date = new Date(eventData.dateEvent.date_tz)

  const isEventCurrentlyOpen =
    Dates.isAfter(new Date(), new Date(eventData.dateOpen.date_tz)) &&
    Dates.isBefore(new Date(), new Date(eventData.dateEnd.date_tz))

  useEffect(() => {
    if (showTickets && !fetchBulkData) {
      setFetchBulkData(true)
    }
  }, [showTickets])

  if (isUsable && !isEventCurrentlyOpen) {
    return null
  }

  if (!isUsable && !isPastEvent && isEventCurrentlyOpen) {
    return null
  }

  if (setIsThereAtLeastOne) {
    setIsThereAtLeastOne(true)
  }

  return (
    <>
      <GridColumn
        gridColumnStart={{ [Breakpoints.laptop]: 2 }}
        gridColumnEnd={{ [Breakpoints.laptop]: 16 }}
        className={classNames(css.walletExtra, {
          [css.isPastEvent]: isPastEvent && !showTickets,
          [css.isUsable]: isUsable,
        })}
        data-testid={`${DataTestId.wallet.extraEventDesktop}-${eventData.id}`}
      >
        <div className={css.left}>
          <div data-testid={DataTestId.wallet.ticketCount} className={css.count}>
            {`x${count}`}
          </div>

          <div className={css.icon}>
            <Img
              src={`/wallet/goodsservices/purple/${getExtraIconImageNameAccordingToPolicy(eventData?.policy?.code)}.svg`}
            />
          </div>

          <div className={css.details}>
            <h2 className={css.name}>{eventData.name}</h2>

            <div className={css.date}>
              <div className={css.day}>{Dates.format(date, t('dates:wallet:date'))}</div>
              <div className={css.time}>&nbsp;/&nbsp;</div>
              <div className={css.time}>{Dates.format(date, t('dates:common:hoursMinutes'))}</div>
            </div>
          </div>
        </div>

        <div className={css.right}>
          <div className={css.actions}>
            <ButtonWhiteBlack
              data-testid={DataTestId.wallet.btnSeeExtra}
              className={css.see}
              onClick={() => setShowTickets((prevState) => !prevState)}
            >
              <h5>{t(showTickets ? 'wallet:hideExtra' : 'wallet:seeExtra')}</h5>
            </ButtonWhiteBlack>
          </div>
        </div>
      </GridColumn>

      {fetchBulkData && <TicketDataFetcher eventId={eventData.id} />}

      {showTickets && <UserExtras walletEventData={walletEventData} eventData={eventData} />}
    </>
  )
}

export default WalletExtraDesktop
